export const createQueryString = (params: {
  [key: string]: number | string | boolean | undefined;
}) => {
  const queryConstructor = new URLSearchParams();

  for (let key in params) {
    const value = params[key];

    if (value !== undefined) {
      queryConstructor.append(key, `${value}`);
    }
  }

  return queryConstructor.toString();
};
